import React from 'react';
import office from '../../assets/images/icons/ICToffice.jpg';
import Dean from '../../assets/images/icons/teklay.jpg';
import '../../assets/css/style.css';
import UnderlineWithIcon from '../components/UnderlineWithIcon';
const CentralICT = () => {
  return (
    <div>
      <div className="banner-slide">
        <img src={office} alt="Central ICT Office" className="banner-image" />
        <div className="banner-content">
          <h2>TRANSFORMING THE LEARNING ENVIRONMENT THROUGH CUTTING-EDGE TECHNOLOGY AND INNOVATIVE SOLUTIONS.</h2>
        </div>
      </div>

      <section className="projects-details">
        <h3>OFFICE OF CENTRAL ICT</h3>
		  <UnderlineWithIcon/>
        <div className="auto-container">
          <div className="text-block">
            <div className="row">
              <div className="col-lg-10">
                <p>
                  The mission of the ICT office is to enhance educational experience by providing robust technological infrastructure,
                  innovative solutions, and reliable support services. The office aims to facilitate learning, teaching, research,
                  and administration through effective use of information and communication technologies.
                </p>
              </div>
            </div>
          </div>

          <div className="text-block">
            <div className="row">
              <div className="col-lg-6">
                <h4>MEET THE VICE PRESIDENT FOR CENTRAL ICT</h4>
                <p>
                  Mr. Teklay Hagos has over 15 years of experience in the field of information and communication technology. 
                  He holds a MSc in Computer Science and has made significant contributions 
                  to the development of ICT infrastructure at various institutions. His leadership is marked by a commitment 
                  to innovative educational solutions and the enhancement of learning experiences through technology.
                </p>
              </div>
              <div className="col-lg-4">
                <div className="image">
                  <img src={Dean} alt="Dean Teklay Hagos" className="vp-image" />
                </div>
                <p className="designation">Teklay Hagos</p>
                <p>VP, Central ICT Office</p>
              </div>
            </div>
          </div>

          <hr />

          <div className="text-block-two">
            <div className="row">
              <div className="col-lg-12">
                <h4>OUR SERVICES AND FACILITIES</h4>
                <ul className="services-list">
                  <li><div className="icon-box"><span className="flaticon-book"></span>Website Services</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Institutional Cloud Email</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Wired and Wireless Connectivity Services Across All Campuses</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Private Cloud Compute and Storage Infrastructure</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Learning Management System (LMS)</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Digital Libraries and Institutional Repository</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Student Information Management Systems</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Technology Enhanced Classrooms</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Security Enhancement Services</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>System Development</div></li>
                  <li><div className="icon-box"><span className="flaticon-book"></span>Training and Consultancy</div></li>
                </ul>
              </div>
            </div>
          </div>

          <hr />

          <div className="contact-block">
            <h4>CONTACT US</h4>
            <div className="text">
              For any ICT-related queries or technical assistance, please reach out to us:
              <br />
              Email: <a href="mailto:info@admasuniversity.edu.et">info@admasuniversity.edu.et</a>
              <br />
              Phone: +251 944 700 068
              <br />
              Office Location: Olympia, 604, Admas University
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CentralICT;